import { useState } from 'react';
import { BellIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';

export default function NotificationDropdown({ notifications = [] }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative">
      {/* 🔔 Icône notification */}
      <button
        onClick={() => setOpen(!open)}
        className="relative p-2 rounded-md hover:bg-light-secondary/20 dark:hover:bg-dark-secondary/20"
      >
        <BellIcon className="h-6 w-6 text-white" />
        {notifications.length > 0 && (
          <span className="absolute top-0 right-0 h-2 w-2 bg-red-500 rounded-full" />
        )}
      </button>

      {/* 📦 Dropdown des notifications */}
      {open && (
        <div className="absolute right-0 mt-2 w-80 bg-light-surface dark:bg-dark-bg rounded-md shadow-lg ring-1 ring-black ring-opacity-5 z-50">
          <div className="max-h-64 overflow-y-auto custom-scroll px-4 py-2 space-y-3">
            {notifications.length === 0 ? (
              <p className="text-sm text-gray-500 dark:text-gray-400">Aucune notification</p>
            ) : (
              notifications
                .sort((a, b) => new Date(b.date) - new Date(a.date))
                .map((notif, idx) => (
                  <div key={idx} className="text-sm text-light-text dark:text-dark-text">
                    <p className="font-medium">{notif.title}</p>
                    <p className="text-xs text-light-text-muted dark:text-dark-text-muted">{notif.message}</p>
                  </div>
                ))
            )}
          </div>

          {/* 🔗 Lien vers page Notifications */}
          <div className="px-4 py-2 border-t border-light-tertiary/10 dark:border-dark-tertiary/20">
            <Link
              to="/notifications"
              className="text-sm text-light-primary dark:text-dark-primary hover:underline"
              onClick={() => setOpen(false)}
            >
              Voir toutes les notifications
            </Link>
          </div>
        </div>
      )}
    </div>
  );
}
